<!--

    * UBCO Navbar with custom functionality *
    This is a UBCO navbar that gets it's styles from the CDN but svelte for it's logic
    ? WARNING: Try not to touch the styles as they can conflict with the UBC styles.

-->

<script lang="ts">

import { link } from "svelte-routing";
import { createEventDispatcher, onMount } from 'svelte';
import { fetchMajorResearchItems } from "../services/major-research";
import { fetchResearchItems } from "../services/research";
import type { MajorProject } from "../structs";

const dispatch = createEventDispatcher();


onMount(() => {
    setResearchCategories();
})

const researchFetch = new Promise(async (resolve: (data: any[]) => void) => {
    let data = await fetchResearchItems();
    resolve(data);
});

const majorProjectsFetch = new Promise(async (resolve: (data: MajorProject[]) => void) => {
    let data = await fetchMajorResearchItems();
    resolve(data);
});

let researchCategories = [];

async function setResearchCategories() {
    let data = await researchFetch;
    let categories = [];
    data.forEach(category => {
        category.items.forEach(e => {
            if (!categories.find(a => a == e.status)) {
                categories.push(e.status)
            }
        });
    });
    researchCategories = categories;
}
    
</script>

<!-- UBC Unit Navigation (for mobile phones) -->
<div id="ubc7-unit-menu" class="navbar expand" role="navigation">
    <div class="navbar-inner expand">
        <div class="container">
            <div class="nav-collapse collapse" id="ubc7-unit-navigation">
                <ul class="nav">
                    <li><a href="/" use:link>Home</a></li>
                    <!-- Research Dropdown -->
                    <li class="dropdown">
                        <div class="btn-group">
                            <a class="btn" href="/?anchor=research" on:click={() => dispatch('researchAnchorClicked')} use:link>Research</a>
                            <button class="btn dropdown-toggle" data-toggle="dropdown"><span class="ubc7-arrow blue down-arrow"></span></button>
                            
                            {#await researchFetch then researchData}
                                <!-- svelte-ignore a11y-missing-attribute -->
                                <ul class="dropdown-menu">
                                    {#each researchCategories as category}
                                        <div class="drop-down-category">
                                            <li class="drop-down-entry">
                                                <a>{category}</a>
                                                <span class="ubc7-arrow blue down-arrow"></span>
                                            </li>
                                            <div class="drop-down">
                                                {#each researchData as item}
                                                    {@const isCategoryEmpty = (item.items.filter(e => e.status.replace(/\s/g, '-').toLowerCase() == category.replace(/\s/g, '-').toLowerCase())).length < 1}
                                                    
                                                    {#if item.items.length > 0 && !isCategoryEmpty}
                                                        <li><a href="/projects/{item.category.replace(/\s/g, '-').toLowerCase()}/{category.replace(/\s/g, '-').toLowerCase()}" use:link>
                                                            {item.category}
                                                        </a></li>
                                                    {/if}
                                                {/each}
                                            </div>
                                        </div>
                                    {/each}
                                </ul>
                            {/await}
                            
                        </div>
                    </li>

                    {#await majorProjectsFetch then majorProjects}
                        {#each majorProjects as project}
                            <li><a href="/major-projects/{project.id}" use:link>{project.name}</a></li>
                        {/each}
                    {/await}
                    
                    <li><a href="/publications" use:link>Publications</a></li>
                    <li><a href="/tools" use:link>Tools</a></li>
                    <li><a href="/collaborations" use:link>Collaborations</a></li>
                    <li><a href="/people" use:link>Our Team</a></li>
                    <li><a href="/contact" use:link>Contact</a></li>
                    <li><a href="/about" use:link>About Us</a></li>
                </ul>	
            </div> <!-- /.nav-collapse -->
        </div>
    </div><!-- /navbar-inner -->
</div><!-- /navbar -->
<!--End of UBC Unit Navigation -->


<style lang="sass">

.drop-down-category
    &:hover 
        li.drop-down-entry 
            background-color: #002145
            color: white
            
            a
                color: white

        .drop-down
            max-height: 200px

    .drop-down-entry
        display: flex
        flex-direction: row
        align-items: center
        color: #002145
        padding: 6px 15px
        font-weight: bold 
        text-transform: capitalize

        a
            flex-grow: 1

    .drop-down
        overflow: hidden
        max-height: 0
        transition: max-height 0.3s ease

        li
            display: block
            padding: 0
            display: flex

            a  
                width: 100%
                display: block
                padding: 3px 20px
                color: #002145
                cursor: pointer


</style>